import React, { Component } from 'react'
import moment from 'moment'
import Big from 'big.js'
import { SingleDatePicker } from 'react-dates'
import { QueryService } from 'services/queries'
import ErrorType from 'services/ErrorType'
import config from 'services/config'
import MoneyValue from 'components/MoneyValue'

import 'react-dates/lib/css/_datepicker.css'

//import jQuery from 'services/jQueryDatatablesBootstrap'
import { BootstrapTable, TableHeaderColumn, ExportCSVButton } from 'react-bootstrap-table';
import 'react-bootstrap-table/dist/react-bootstrap-table-all.min.css';

import Spinner from 'react-spinkit'

let _validNumber = x => { try { Big(x); return true } catch (e) { return false } }


let _moneyFormat = value => _validNumber(value) ? (<MoneyValue value={value}/>) : (<span className={'clear-value'}>{value}</span>)
let _dateFormat = date => moment(date).format('M/D/YYYY')
let _humanize = s => {
  return s ? s.replace(/_/g, ' ').trim().replace(/([^\s])([A-Z])/g, '$1 $2').replace(/\b[A-Z][a-z]+\b/g, function (x) {
    return x.toLowerCase();
  }).replace(/^[a-z]/g, function (x) {
    return x.toUpperCase();
  }) : null;
};


class AccountSummaryAge extends Component {

  render() {

    return (
      <div className="card">
        <h3 className="card-title">
          Summary for {_humanize(this.props.data[0].contract)}
          <div className="pull-right"><MoneyValue value={this.props.data[0].balance}/></div>
        </h3>
          <table className="table table-condensed">
            <thead>
              <tr>
                <th className="col-md-2 text-left"></th>
                <th className="col-md-1 text-right border-right">Balance</th>
                <th className="col-md-1 text-right">Amount past due</th>
                <th className="col-md-1 text-right">Days past due</th>
                <th className="col-md-1 text-right">0-15 days</th>
                <th className="col-md-1 text-right">16-30 days</th>
                <th className="col-md-1 text-right">31-60 days</th>
                <th className="col-md-1 text-right">61-120 days</th>
                <th className="col-md-1 text-right">120+ days</th>
              </tr>
            </thead>
            <tbody>
              {this.props.data.map(row => ( (row.balance != 0) &&
                <tr className={ !row.journal ? 'warning' :'' }>
                  <td className="text-left">{_humanize(row.journal_display) || 'Total outstanding'}</td>
                  <td className="text-right border-right"><MoneyValue value={row.balance}/></td>
                  <td className="text-right"><MoneyValue value={row.balance_due}/></td>
                  <td className="text-right">{row.days_past_due}</td>
                  <td className="text-right"><MoneyValue value={row.balance_0_15}/></td>
                  <td className="text-right"><MoneyValue value={row.balance_16_30}/></td>
                  <td className="text-right"><MoneyValue value={row.balance_31_60}/></td>
                  <td className="text-right"><MoneyValue value={row.balance_61_120}/></td>
                  <td className="text-right"><MoneyValue value={row.balance_120_plus}/></td>
                </tr>
              ))}
            </tbody>
          </table>
      </div>
    )

  }

}

class TransactionEntries extends Component {

  render() {
    if (this.props.data)
      return (
        <div>
          <BootstrapTable
              data={this.props.data}
              bordered={true}
              condensed
              tableHeaderClass={'header-hidden'}
              headerStyle={{ display: 'none' }}
              tableStyle={{ margin: -8, borderRadius: 0, border: 0 }}
              options={{
                defaultSortName: 'post_date',
                defaultSortOrder: 'asc'
              }}
          >
            <TableHeaderColumn width="24"></TableHeaderColumn>
            <TableHeaderColumn dataField="transaction_id" isKey hidden export>Transaction #</TableHeaderColumn>
            <TableHeaderColumn dataField="post_date" dataFormat={_dateFormat} csvFormat={_dateFormat} dataSort dataAlign="right" width="8em">Post date</TableHeaderColumn>
            <TableHeaderColumn dataField="transaction_type" dataFormat={_humanize} csvFormat={_humanize}>Transaction</TableHeaderColumn>
            <TableHeaderColumn dataField="contract" dataAlign="left">Contract #</TableHeaderColumn>
            <TableHeaderColumn dataField="tranche" dataAlign="left">Tranche #</TableHeaderColumn>
            <TableHeaderColumn dataField="entity" dataAlign="left">Entity</TableHeaderColumn>
            <TableHeaderColumn dataField="debits" dataFormat={_moneyFormat} dataAlign="right" width="8em">Debits</TableHeaderColumn>
            <TableHeaderColumn dataField="credits" dataFormat={_moneyFormat} dataAlign="right" width="8em">Credits</TableHeaderColumn>
            <TableHeaderColumn dataField="ending_balance" dataFormat={_moneyFormat} dataAlign="right" width="10em">Ending balance</TableHeaderColumn>
          </BootstrapTable>
        </div>
      )
  }

}

class AccountsTable extends Component {

  expandColumnComponent({ isExpandableRow, isExpanded }) {
    return isExpandableRow && <img src={`/images/icon-gray-carat-${isExpanded ? 'down' : 'right'}.png`}/>
  }

  render() {

    return (
      <div className="card">
        <div className="card-body">
          <h3 className="card-title">Transaction history</h3>
          { (this.props.loading) && <Spinner name='circle' /> }
          <BootstrapTable
            data={this.props.data}
            pagination
            exportCSV
            csvFileName={'account_' + this.props.account + '_balances_' + this.props.date.format('YYYY_MM_DD') + '.csv'}
            search
            expandableRow={  row => row.detail ? true : false }
            expandComponent={ row => <TransactionEntries data={row.detail} /> }
            expandColumnOptions={{
              expandColumnVisible: true,
              expandColumnComponent: this.expandColumnComponent,
              expandColumnBeforeSelectColumn: false,
              columnWidth: 24
            }}
            options={{
              expandBy: 'column',
              sizePerPage: 50,
              paginationShowsTotal: true,
              paginationPosition: 'top',
              hideSizePerPage: true,
              defaultSortName: 'post_date',
              defaultSortOrder: 'asc',
              exportCSVBtn: () => <ExportCSVButton className='btn-blue'/>
            }}>
            <TableHeaderColumn dataField="transaction_id" isKey hidden export>Transaction #</TableHeaderColumn>
            <TableHeaderColumn dataField="post_date" dataFormat={_dateFormat} csvFormat={_dateFormat} dataSort dataAlign="right" width="8em">Post date</TableHeaderColumn>
            <TableHeaderColumn dataField="transaction_type" dataFormat={_humanize} csvFormat={_humanize} width="12em">Transaction</TableHeaderColumn>
            <TableHeaderColumn dataField="contract" dataFormat={_humanize} dataAlign="left" width="8em">Contract #</TableHeaderColumn>
            <TableHeaderColumn dataField="entity" dataFormat={_humanize} dataAlign="left" width="21em">Details</TableHeaderColumn>
            <TableHeaderColumn dataField="debits" dataFormat={_moneyFormat} dataAlign="right" width="8em">Debits</TableHeaderColumn>
            <TableHeaderColumn dataField="credits" dataFormat={_moneyFormat} dataAlign="right" width="8em">Credits</TableHeaderColumn>
            <TableHeaderColumn dataField="ending_balance" dataFormat={_moneyFormat} dataAlign="right" width="10em">Ending balance</TableHeaderColumn>
            <TableHeaderColumn dataField="tranche" dataAlign="left" width="20em">Notes</TableHeaderColumn>
            {/*<TableHeaderColumn dataField="activity_id" dataAlign="right">Activity #</TableHeaderColumn>
            <TableHeaderColumn dataField="journal" dataFormat={_humanize} csvFormat={_humanize} width="10em">Journal</TableHeaderColumn>
            <TableHeaderColumn dataField="balance_type" dataFormat={_humanize} csvFormat={_humanize} width="12em">Balance type</TableHeaderColumn>
            <TableHeaderColumn dataField="fee_id" dataAlign="right">Fee #</TableHeaderColumn>
            <TableHeaderColumn dataField="invoice_id" dataAlign="right">Invoice #</TableHeaderColumn>*/}
          </BootstrapTable>

        </div>
      </div>
    )
  }
}

class ScheduleTable extends Component {

  render() {

    return (
      <div className="card">
        <div className="card-body">
          <h3 className="card-title">Payment schedule</h3>
          <BootstrapTable
            data={this.props.data}
            pagination
            exportCSV
            csvFileName={'account_' + this.props.account + '_schedule_' + this.props.date.format('YYYY_MM_DD') + '.csv'}
            search
            options={{
              sizePerPage: 24,
              paginationShowsTotal: true,
              paginationPosition: 'top_bottom',
              hideSizePerPage: true,
              defaultSortName: 'due_date',
              defaultSortOrder: 'asc',
              exportCSVBtn: () => <ExportCSVButton className='btn-blue'/>
            }}
            trStyle={ r => r.past_due ? {backgroundColor: '#faf3f0'} : {}}
          >
            <TableHeaderColumn dataField="contract" hidden export>Contract</TableHeaderColumn>
            <TableHeaderColumn dataField="due_date" isKey dataFormat={_dateFormat} csvFormat={_dateFormat} dataSort dataAlign="right" width="8em">Due date</TableHeaderColumn>
            <TableHeaderColumn dataField="debits" dataFormat={_moneyFormat} dataAlign="right" width="8em">Original amount</TableHeaderColumn>
            <TableHeaderColumn dataField="balance" dataFormat={_moneyFormat} dataAlign="right" width="8em">Currently outstanding</TableHeaderColumn>
            <TableHeaderColumn dataField="past_due" dataAlign="right" width="8em">Days past due</TableHeaderColumn>
            <TableHeaderColumn dataField="adjustment" dataFormat={_humanize} dataAlign="left" width="8em">Notes</TableHeaderColumn>
          </BootstrapTable>

        </div>
      </div>
    )
  }
}

/*
            <TableHeaderColumn dataField="debits_principal" dataFormat={_moneyFormat} dataAlign="right" width="8em">Principal</TableHeaderColumn>
            <TableHeaderColumn dataField="debits_interest" dataFormat={_moneyFormat} dataAlign="right" width="8em">Interest</TableHeaderColumn>
            <TableHeaderColumn dataField="debits_fees" dataFormat={_moneyFormat} dataAlign="right" width="8em">Fees</TableHeaderColumn>
            <TableHeaderColumn dataField="credits" dataFormat={_moneyFormat} dataAlign="right" width="8em">Paid</TableHeaderColumn>
*/

class Accounts extends Component {

  constructor(props) {

    super(props)
    this.state = {
      account: '',
      balanceDate: moment(), //this.props.maxDate,
      balanceDateFocus: false,
      summary: [],
      balances: [],
      schedule: [],
      currentPage: 1,
      pageSize: 100,
      recordCount: 0,
      loading: false
    }

    this.onBalanceDateChange = this.onBalanceDateChange.bind(this)
    this.onBalanceDateFocusChange = this.onBalanceDateFocusChange.bind(this)
    this.isOutsideBalanceDateRange = this.isOutsideBalanceDateRange.bind(this)
    this.onPaginationChanged = this.onPaginationChanged.bind(this)
    this.onInputChange = this.onInputChange.bind(this)
    this.onAccountKeyPress = this.onAccountKeyPress.bind(this)
    this.fetchBalances = this.fetchBalances.bind(this)
    this.fetchAccountBalanceDetails = this.fetchAccountBalanceDetails.bind(this)
    this.fetchAccountBalanceSummary = this.fetchAccountBalanceSummary.bind(this)

    if (this.props.location.state && this.props.location.state.account)
      this.state.account = this.props.location.state.account
    if (this.props.location.state && this.props.location.state.date)
      this.state.balanceDate = moment(this.props.location.state.date)

    this.queryService = new QueryService(this.props.book)

  }

  componentWillMount() {
    this.fetchBalances(this.state.account, this.state.balanceDate)
  }


  onBalanceDateFocusChange(p) {
    this.setState({
      balanceDateFocus: p.focused
    })
  }

  onBalanceDateChange(date) {
    //date = moment(date).endOf('month')
    this.fetchBalances(this.state.account, date)
  }


  onInputChange(event) {
    const target = event.target;
    this.setState({
      [target.name]: target.value
    });
  }



  onAccountKeyPress(event) {
    if (event.key === 'Enter') {
      this.fetchBalances(this.state.account, this.state.balanceDate)
    }
  }


  async fetchAccountBalanceSummary(account, date) {
    try {
      let result = await this.queryService.getAccountBalanceSummary(account, date)
      console.log(result.summary)
      this.setState({
        summary: result.summary
      })
    } catch (err) {
      if (err && err.type) {
        if (err.type === ErrorType.Authorization) {
          this.props.history.push(config.loginPage)
          return
        }
      }
      throw err
    }
  }

  async fetchAccountBalanceDetails(account, date, limit = null) {
    try {
              
      let result = await this.queryService.getAccountBalanceDetails(account, date, limit)
      
      let balances = result.balances
        .map (row => {
          if (row.transaction_type.toLowerCase() == 'payment') {
            row.detail = row.payment_detail.sort( (a, b) => (b.transaction_type > a.transaction_type ? -1 : 1) )
          }
          return row
        })
        .reduce( (acc, row) => {
          let running_balance = (acc && acc.length > 0) ? acc.slice(-1)[0].ending_balance : 0
          row.ending_balance = running_balance - parseFloat(row.credits) + parseFloat(row.debits)
          acc.push(row)
          return acc
        }, [])
        .reduce( (acc, row) => {
          let last = acc.pop()
          if (last &&
            ((['interest', 'void_interest', 'entity_transfer', 'void_entity_transfer', 'cash_transfer'].includes(last.transaction_type.toLowerCase()) && row.transaction_type == last.transaction_type)
            || (row.event_id == last.event_id))) {
              let sumRow = {...last}
              if (!sumRow.detail) {
                sumRow.detail = [last]
              }
              sumRow.transaction_id = row.transaction_id
              sumRow.debits = Big(sumRow.debits).plus(Big(row.debits))
              sumRow.credits = Big(sumRow.credits).plus(Big(row.credits))
              sumRow.post_date = row.post_date
              sumRow.ending_balance = row.ending_balance
              sumRow.entity = row.entity
              sumRow.detail.push(row)
              delete sumRow.detail
              acc.push(sumRow)
          } else {
            if (last) acc.push(last)
            delete row.detail
            acc.push(row)
          }
          return acc
        }, [])
      
      this.setState({
        balances: balances,
        loading: (limit !== null)
      })
  
    } catch (err) {
      if (err && err.type) {
        if (err.type === ErrorType.Authorization) {
          this.props.history.push(config.loginPage)
          return
        }
      }
      throw err
    }
  }

  async fetchAccountSchedule(account, date) {
    try {
      let result = await this.queryService.getAccountSchedule(account, date)
      for (let r of result.schedule) {
        (r.adjustments) && (
          r.adjustment = JSON.parse(r.adjustments)
            .filter( a => a.end_date ? moment(r.due_date).isBetween(a.start_date, a.end_date, 'day', '[)') : moment(r.due_date).isSameOrAfter(a.start_date, 'day'))
            .reduce( (m, a) => (moment(a.timestamp).isAfter(m.timestamp) ? a : m), {timestamp: moment(0)}).type
        )
        if (r.adjustment == 'reset') r.adjustment = null
        r.past_due = (r.days_past_due && (r.days_past_due > r.grace_period)) ? r.days_past_due : null
        if (Big(r.balance).eq(0) && r.latest_credit_posted_at) r.balance = `Cleared on ${moment(r.latest_credit_posted_at).format('M/D/YYYY')}`
      }
      console.log(result.schedule)
      this.setState({
        schedule: result.schedule
      })
    } catch (err) {
      if (err && err.type) {
        if (err.type === ErrorType.Authorization) {
          this.props.history.push(config.loginPage)
          return
        }
      }
      throw err
    }
  }



  async fetchBalances(account, date) {
    if (!account) return null
    this.fetchAccountBalanceSummary(account, date)
    //await this.fetchAccountBalanceDetails(account, date, 50)
    this.fetchAccountBalanceDetails(account, date)
    this.fetchAccountSchedule(account, date)
    this.setState({
      balanceDate: date,
      account: account
    })
  }


/*
  async _fetchBalances(account, date) {
    try {
      if (!account) return null
      let result = await queryService.getAccountDetails(account, date)
      console.log(result)

      return {
        balances: result.balances,
        summary: result.summary,
        balanceDate: date,
        account: account
      }
    } catch (err) {
      if (err && err.type) {
        if (err.type === ErrorType.Authorization) {
          this.props.history.push(config.loginPage)
          return
        }
      }
      throw err
    }
  }
*/

  isOutsideBalanceDateRange(date) {
    return moment().add(7, 'days').isBefore(date)
  }

  onPaginationChanged(pagination) {

  }

  render() {
    return (
      <div className="content-wrapper">
        <div className="page-title">
          <div>
            <h1><i className="fa fa-th-list"></i> Contract details</h1>
            <p>Outstanding balances and transaction history</p>
          </div>
          <div className="form-inline">
{/*            <label className="header-input">
              <span className="period">Journal</span>
              <select className="form-control">
                <option value="cash">Cash</option>
                <option value="buyer_receivables">Buyer receivables</option>
                <option value="seller_receivables">Seller receivables</option>
                <option value="expenses">Expenses</option>
                <option value="seller_payables">Seller payables</option>
                <option value="revenues">Revenues</option>
              </select>
            </label> */}
            <label className="header-input">
              <span className="period">Contract</span>
              <input className="form-control" name="account" type="text" autoFocus={true}
                     value={this.state.account} onChange={this.onInputChange} onKeyPress={this.onAccountKeyPress} />
            </label>
            <label className="header-input">
              <span className="period">Date</span>
              <SingleDatePicker
                date={this.state.balanceDate}
                onDateChange={this.onBalanceDateChange}
                onFocusChange={this.onBalanceDateFocusChange}
                focused={this.state.balanceDateFocus}
                numberOfMonths={1}
                isOutsideRange={this.isOutsideBalanceDateRange} />
            </label>

            {/*<ul className="breadcrumb">
              <li><i className="fa fa-home fa-lg"></i></li>
              <li>Tables</li>
              <li className="active"><a href="#">Simple Tables</a></li>
            </ul>*/}
          </div>
        </div>
          <div className="row small">
          { (this.state.summary.length > 0) &&
            <div className="col-md-12">
              <AccountSummaryAge data={this.state.summary} />
            </div>
          }
          { (this.state.balances.length > 0) && (this.state.summary.length > 0) &&
            <div className="col-md-12">
              <AccountsTable
                data={this.state.balances}
                account={this.state.summary[0].account}
                date={this.state.balanceDate}
                loading={this.state.loading}
              />
            </div>
          }
          { (this.state.schedule.length > 0) && (this.state.summary.length > 0) &&
            <div className="col-md-12">
              <ScheduleTable
                data={this.state.schedule}
                account={this.state.summary[0].account}
                date={this.state.balanceDate}
              />
            </div>
          }
          </div>
      </div>
    )
  }
}

export default Accounts

//                onDateChange={this.onBalanceDateChange}
//                onFocusChange={this.onBalanceDateFocusChange}
//                focused={this.state.balanceDateFocus}



// WEBPACK FOOTER //
// ./src/containers/Dashboard/Accounts/index.js